<template>
    <div>         
        <div @click="getSaveFile(file)" class="d-flex p-2">   
            <div class="d-flex p-2" :style="nombreFile ? 'cursor: pointer;' : ''" style="border: 1px solid #E5E7E9; ">
                <div class="px-2" style="border-right: 1px solid #E5E7E9;">
                    <i class="far fa-file-alt"></i>
                </div>
                <p class="mb-0 px-2">{{nombreFile ? file.filename : 'Descargando'}}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['file'],
    data(){
        return{
            nombreFile: true
        }
    },
    methods:{
        getSaveFile(file){
            this.nombreFile = false
            try {
                if(this.nombreFile == false){
                    const url = '/api/v1/mailing/attachment/'+ file.id
                    window.open(url)
                }
                this.nombreFile = true;
            }catch (e) {
                this.nombreFile = true;
                console.error(e)
                // loading.close()
            }
        },
    }
}
</script>
